import AnalyticsReport from "./report";

export default AnalyticsReport;
